import axios from 'axios'
import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant'
import { Button } from '@material-ui/core'
import Loader from '../../../common/Loader'

import CheckPermission from '../../../common/Permissions/CheckPermission'

class TripExcelUpload extends React.Component {
  state = {
    isLoading: false,

    excelFile: '',
    image_excel: '',
    excelUploadErrors: [],
  }

  componentDidMount() {}

  handleExcelChange = (e) => {
    const reader = new FileReader()
    const name = e.target.name

    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0]
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        this.setState({
          [name]: reader.result,
        })
      }
    } else {
      this.setState({
        [name]: '',
      })
    }
  }

  submitExcel = async () => {
    if (this.state.excelFile) {
      this.setState({ isLoading: true })
      const data = {
        file: this.state.excelFile,
        type: 'TR',
      }

      await axios
        .post(Constant.getAPI() + '/admin/meta-boat-excel-import', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState(
            {
              isLoading: false,
              excelFile: '',
              excelUploadErrors: res?.data?.data?.error || [],
            },
            () => {
              this.image_excel.value = null
            }
          )
          Swal.fire({
            title: 'Trip Details Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ isLoading: false })
        })
    }
  }

  downloadSampleMetaListExcelFile = async () => {
    this.setState({ isLoading: true })

    await axios
      .get(Constant.getAPI() + '/admin/meta-details-excel-export', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        const data = res.data.data
        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  getMetaListExcelFile = async () => {
    this.setState({ isLoading: true })

    await axios
      .get(Constant.getAPI() + '/admin/get-meta-list-excel-export', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          type: 'TR', // Trip
        },
      })
      .then(async (res) => {
        const data = res.data.data
        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  render() {
    return (
      <CheckPermission permission={'manage-meta-tags'}>
        <div className="card">
          <div className="card-block">
            {this.state.isLoading && (
              <Loader
                open={true}
                fullPage={true}
              />
            )}
            <div className="row">
              <div
                className="col-md-12"
                style={{ marginBottom: 20 }}
              >
                <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                  Trip Data Controller
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.downloadSampleMetaListExcelFile}
                    className="f-right ml-1"
                    startIcon={<i className="icofont icofont-upload-alt"></i>}
                  >
                    Export Sample file
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.getMetaListExcelFile}
                    className="f-right ml-1"
                    startIcon={<i className="icofont icofont-upload-alt"></i>}
                  >
                    Export List
                  </Button>
                </div>
              </div>

              <div className="col-6">
                <div className="form-group">
                  <div>
                    <input
                      type="file"
                      id="excelFile"
                      name="excelFile"
                      accept=".xls,.xlsx"
                      className="w-100"
                      onChange={this.handleExcelChange}
                      ref={(ref) => (this.image_excel = ref)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-6">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.submitExcel}
                  className="f-right ml-1"
                  disabled={!this.state.excelFile}
                  startIcon={<i className="icofont icofont-upload-alt"></i>}
                >
                  Upload Meta Data Excel files
                </Button>
              </div>

              {/* <div className="col-12">
                  {this.state.excelUploadErrors.map((item, index) => (
                      <div key={index}>
                          <span style={{ color: '#f00' }}>{item}</span>
                          <br />
                      </div>
                  ))}
              </div> */}
            </div>
          </div>
        </div>
      </CheckPermission>
    )
  }
}

export default TripExcelUpload
